module.exports = __webpack_public_path__ + "img/icon_touxiangbianji.a88d6bab.svg";